// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { useThemeId } from '@tectonics/prs/merchant';
import { getThemeById } from '../../theme/get-theme-by-id';
import { Empty } from '../../atoms';

type Props = {|
  logoSrc: ?string,
  fallbackText: ?string,
|};

export function MerchantLogoDisplay({ logoSrc, fallbackText }: Props): Node {
  const themeId = useThemeId();
  const theme = getThemeById(themeId);

  if(theme.layout.hideMerchantLogo)
    return <Empty />;

  if (logoSrc) {
    return (
      <Root>
        <LogoImage src={logoSrc} alt={fallbackText} />
      </Root>
    );
  }

  return null;
}

const Root = styled.div`
  display: flex;
  justify-content: center;
`;

const LogoImage = styled.img`
  max-height: 80px;
  max-width: 100%;
`;
